
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's014930edaa0fa77d': `Start of Series`,
's016f68d263953ec2': `Remove Account`,
's022ad53b239795d5': `Remove Profile Image`,
's032cd9f1245d3645': `Exhibition space`,
's0379fc73608ab971': `Done`,
's03848d257276adc8': `exact date`,
's03aa3cfb08dff960': `Tags`,
's0491d2d22458cf73': `exceeded number of videos`,
's063be496c545953f': `Signature Remark`,
's06b291180b5c2ef2': `Removing this Artwork will immediately remove it from your list of Artworks.`,
's06ef4755e61fa13f': `Login not successful. Please check your email and login code.`,
's071d99b3ab93bbcb': `Artist group`,
's072af2f9f637f289': `invalid language`,
's0737332ca05ed6df': `Default Content Language`,
's08467b5f9b0bbe38': `Add your own keywords to filter by in the overview`,
's087eb6b22eae8f9c': `Add artwork`,
's08d844177965c733': `Reset filters`,
's09205907b5b56cda': `No`,
's09240e07b5b8d640': `ID`,
's09242e07b5b90ca0': `Id`,
's0994965ba38c3639': `Content can be entered in multiple languages. Select the language in which you want to edit
					content here.
				`,
's0c599150290fb992': `not a string`,
's0c6538ad32621450': str`Removing Artwork "${0}" will immediately remove it from your list
					of Artworks.
				`,
's0d045841254adc83': `Short Description`,
's0e71a5c50cd56f90': `Add Profile Image`,
's0f0202c2780ce439': `Subtitle`,
's0f15b434f2922b08': `whole number`,
's0f2cb376eeeaa423': `Year (start)`,
's0f8a40190d30e7e3': `Edit CVs`,
's10294464c853d9a8': `End of Series`,
's11366a6d9faff00f': `confirmation required`,
's1219d97b49650c05': `Visibility`,
's12631aa651242caf': `description_allowed_accounts`,
's13e72a6392474063': `Profile switched`,
's1641a1c90d9840ec': `draft`,
's165d3919b108ec51': `Bio`,
's17fc59d42b9bc362': `Account Information`,
's1946c13a177a90a1': `Object numbers`,
's19b937c88ca5d2b3': `Invite User`,
's1b23c41934894f30': `Explanation`,
's1b5bba3d9041629a': `Save profile settings`,
's1ba65229592c08d9': `female`,
's1c1134cbda4fe1ee': `invalid format`,
's1c43540556a6117c': `The invitation could not be sent.`,
's1e61bece71b51008': `Removed artworks`,
's1f6a59a2cea667b0': `male`,
's202fffd5a2e1c595': `Length`,
's21900f027f2d7cfa': `Diameter`,
's219c37011b334110': `Add media`,
's242afb3c2ef36c4a': `Insurance Value in €`,
's2468b69d10791c82': `City`,
's2474e7fb1aec9f05': `Test`,
's24d03b95f001a869': `Remove artwork`,
's24ed5ee1f343a2b4': `only partial upload received`,
's24f39319b8853791': `Log`,
's255857544a9d5ec0': `Reset`,
's26f91b6796e33111': `Restore`,
's293aa6a6446fb153': `Export`,
's2a75c946ef4dcab7': `Miscellaneous`,
's2a94ce1cb475c9c2': `You can invite people to help you create this profile. They can view and edit all artworks and
					profile data.
				`,
's2c57913ffd36d298': `First name`,
's2ceb11be2290bb1b': `Cancel`,
's2e558ddd99fd7478': `Edit all selected Artworks`,
's30c9440f8f06fc3c': `exceeded number of files`,
's31b9c53d98feb660': `Request login code`,
's31d694b87ea70f4d': `invalid date`,
's321c03399a143242': `Create Account`,
's3231d0dc6fe30d4a': `Depth`,
's32ac2b6848504809': `Nationality`,
's32b3ac51a9c31f47': `Switch to profile`,
's336c8e1678a8ff80': `Remove item`,
's3375a4920652b810': `Series`,
's33b30147022d7f8c': `Enter code`,
's345fbf4889ae0c7f': `The artwork contains child artworks, please delete them first.`,
's34aa94e923bb3d75': `Out of set`,
's34c31ef2544ae5ee': `Here you can add existing serial numbers, e.g. existing collection numbers or serial numbers you
					have assigned yourself.
				`,
's34d7c565f291023e': `Unsellable`,
's35a9d77ceb9cfe4b': `i.e. position, stamped, ...`,
's37083e19c2f9c755': `Nr.`,
's383f38fbc7a28b77': `file to big`,
's38be98a354b0a135': `Signed`,
's39b85a26b3f40ea4': `divers`,
's3a6129602c615ff1': `edit`,
's3c0d17bad169557b': `none`,
's3cf89cb47fdde7e9': `Link`,
's3dc7f921134f8d35': `Here you can edit your artist profile, curriculum vitae and
					artworks as simple or as detailed as you wish.
				`,
's3f06e9abb6ebcb79': `Characters`,
's3f665d5e5aaa691c': `Profile Information`,
's3f69d47415916068': `trialing.`,
's3f75923d61571772': `unpaid.`,
's402ed9d74111a751': `Creation date to`,
's40cb8c9e0d13243b': `Additional information on material or technique`,
's4261630e96ce4712': `Edit Selected`,
's45ab758ffe13fd9b': `Manage Series`,
's4650b3861340a401': `invited by`,
's477bc7abb235cce6': `Hide filters`,
's47a2a1f01af73025': `Day of death (if applicable)`,
's483ed8121e9b9476': `description_invited_accounts`,
's4880dc3125543292': `Mentions`,
's48e186fb300e5464': `Time`,
's49c6478ea452050b': `The curriculum vitae cannot be saved. Please correct the errors.`,
's4b1d1a1379d84161': `Address (Additional)`,
's4caed5b7a7e5d89b': `English`,
's4cd84215487b493a': `Diagonal`,
's4ced1bd295c3cac3': `Enter EMail to sent invitation`,
's4da81c26ca735d66': `Provenance/Ownership Chronology`,
's4e33f21fc24666c1': `Move Up`,
's4fcd634b4ebc761b': `Add section`,
's5096bdb5f882fb29': `Materials`,
's517acbf1f96324f9': `Weight`,
's523f5d97bb322419': `Account settings`,
's544474a78ecc7b19': `Export Data`,
's5540c926a41a6be9': `Add profile`,
's5590dbf7e425789d': `Label`,
's572aee617031d781': `You can enter and edit your profile and your artworks here.`,
's58d4bced0b668ae6': `not a number`,
's596fa32cf6aa5810': `Location`,
's5a41c3a63f1c18af': `Profile setting`,
's5ccc0b389bfe6048': `No series available`,
's5d7d95ba0d2c4869': `The media date cannot be saved. Please correct the errors.`,
's5d929ff1619ac0c9': `Search`,
's5e8250fb85d64c23': `Close`,
's5e9f4a47a1f2cd25': `Artwork saved successfully.`,
's5f175fdca113e5f1': `Additional Inventory Number`,
's6367df083bd10e6c': `Account with permissions for this profile`,
's63819a470e9c99f9': `Stay on Form`,
's63b877fd01da50e6': str`Removing Account "${0}" will immediately remove it from your list
					of Accounts.
				`,
's63d894b1ddb06289': `Description`,
's63e457bc703a3030': `eMail`,
's63e71d20d1eaca93': `German`,
's64a6dcf9cd66376f': `The form cannot be saved. Please correct the errors.`,
's64eb05dfa49088da': `Manage Accounts`,
's64ef2a6c2dd1d3d1': `Edit`,
's65bbdef13ec0b7ff': `Enter title`,
's65bf0994a56d0c51': `Here you can enter a continuous text. For a detailed tabular list, e.g. of the exhibition
					history, see the CV section
				`,
's663d390fd1b75d7e': `Ownership`,
's67749057edb2586b': `Logout`,
's68631cfbcbebfc30': `No accounts found.`,
's69201fa8972b3e66': `Artwork did not contain any data - it was permanently deleted.`,
's693bdd3f515eca11': `Institution or Location`,
's6a17d95381662d21': `Material/Technique`,
's6b138c631a7d2a2c': `Discard Changes`,
's6c307b439df73478': `All entered data and uploaded media are packed together in a zip archive. You
					will receive a download link at the email address used for your account.
				`,
's6c3970ea23f6d93a': `Profile Permissions`,
's6c3daaac4eed12f9': `Changelog`,
's6c76b294d740446c': `Activity`,
's6cbf5b3254dcbbf3': `Request code again`,
's6cedf419e20c815a': `Phone`,
's6d8c02aee480af7a': `Menu`,
's6e0f65a28704ec9f': `Section name`,
's70d885806b56289e': `enabled`,
's72f2a02e2a5a4ee3': `Media`,
's72f7fe91ebf6cddd': `Copyright/Courtesy`,
's73cdb5bba903a27f': `Replace file`,
's743edce4a1ed0b34': `Is enabled`,
's744bab01318e5b27': `Save Account`,
's74bec541bd25310f': `Artwork`,
's7565a1a1c29dabee': `undated`,
's7575ecc2f357b025': `Save Series`,
's77585085193f50c2': `invalid URL`,
's7858dcc121b436fc': `The profile cannot be saved. Please correct the errors.`,
's7a851c97b5bc30b8': `not an IntegerBool`,
's7c34d7a176d95aa0': `Year (end)`,
's7c61df443de97bf6': str`File duration exceeds the limit of
					${0}
					minutes for
					${1}
					files.
				`,
's7c6c090d491c4cdd': `You have reached the limit of video files.`,
's7d38fc29b20f951b': `Basic information`,
's7d8d449c7a0483c8': `No media available for this artwork.`,
's7dfa029dab05b042': `Edit Artworks`,
's7f59f507e02a2f38': `View`,
's803ce7e1a2294d50': `Files`,
's804ca9ce39d5c56b': `Request Code`,
's814ca8490eb230c0': `Artwork added successfully.`,
's821ef36d63a8a111': `Last modified on`,
's82665b2ffabc9c0a': `Website`,
's832ef3a7593a8b05': `Caption`,
's846b3790b6e25c1c': `Account`,
's855aaab4663315b4': `Artworks`,
's860dbc68e0f2b4c8': `error/uploadUnableToWrite`,
's8641b6c3688a0cec': `Edit artists profile`,
's8677baad3bf6b295': `Save CV`,
's87a55464116c3f48': `Move Down`,
's87bae2710b2492c3': `Contact`,
's881e3183ff4b701d': `error/uploadMissingTmpDir`,
's88ceb91846876e6f': `i.e. estimated, decade`,
's8a0e1c7e1ec3133b': `Is Test`,
's8a6c0085cb6c64a0': `Gender`,
's8ac6ca24f22e5e3f': `Sold`,
's8d5e9fed33847725': `tooltip_publication`,
's8d8622e68bd10109': `Invite Editor`,
's90c91b0f7a13cb65': `The Form has unsaved changes. Do you really want to leave?`,
's918bfaab4d882918': `Export in preparation. Please check your email.`,
's927497135cdabe78': `Untitled`,
's92921878e886e36d': `Period of collaboration`,
's92fef0e2fba7468c': `Language settings`,
's931ba7d0f5588be8': `Default language`,
's93c046d8c5bb2047': `Date of birth`,
's948766ad031e1c27': `eMail`,
's9502410942da6b88': `CV entry`,
's95a75a2392af5780': `Last name`,
's965c503c3e42fdfe': `Enabled`,
's9739d36feb7c7948': `file type not allowed`,
's988887185a1c094d': `Manage my Subscription`,
's98b32ef4a0856c08': `No Title`,
's99f110d27e30b289': `Title`,
's9aa73ae46dcc23b6': `Collaboration`,
's9b1394a1375404d4': `Is Remains`,
's9c470e19f779025e': `has logged in`,
's9cbe5dc90f48558d': str`Removing Series "${0}" will immediately delete it. The artworks in
					this series remain in the artwork list.
				`,
's9cf7402fe920f7d1': `Country`,
's9d0a3b8de87941d8': `Purchasing price in €`,
's9d8b8aa2b404c2c8': `Settings`,
's9e92503bfc80d2d6': `Genre/Medium of artwork`,
's9f5a5f23312798f0': `Members`,
'sa0541ec14dd4b89c': `Rejection required`,
'sa080ed80aad67329': `file to long`,
'sa0de761979ffad7b': `Failed to upload image`,
'sa1dc38bb8e8339f3': `Pen name`,
'sa2686cd9fcc26088': `Save artwork`,
'sa27166ead3628e16': `Choose a plan`,
'sa3b6be7528aa09f6': `Select language for input. To switch ui langauges, use "UI Language" in the account menu.
				`,
'sa48f81f001b893d2': `User`,
'sa4bd17adfcc9780c': `Damaged`,
'sa512fd0aa10743a6': `New Account`,
'sa5d2f9afa34fd3c3': `Request code`,
'sa65a95e0199f2647': `error/invalidInput`,
'sa6f2645578b2d2bc': `Year`,
'sa75e401db49f2efc': `Remove from Series`,
'sa7e28eff7384ceee': `Mark as important`,
'sa84953c4bf74abca': `Edit Series`,
'sa87645df04d5260a': `Artwork was moved to the Removed Artworks. It will be deleted in 7 days.`,
'saaabc03c55126dc2': `Upgrade`,
'saae1c70e168b45b4': `Admin`,
'sae239213b7c70376': `State`,
'sae42bf06e5c4bbe5': `Enter eMail`,
'saf0bb10217436af6': `Activity Log`,
'saffa23915bede5a1': `Zipcode`,
'sb061ff5a347a296e': `Profile`,
'sb0f8ba7eed402d21': `Curriculum vitae saved successfully.`,
'sb28076159e581755': `Edit images / media`,
'sb2d399c56e156311': `Publication permitted`,
'sb3d83599db5a09be': `Artworks in this Series`,
'sb41210de4f64f7e1': `zero required`,
'sb8bf01b381b893bb': `one required`,
'sb971debc37bf0b54': `Owner`,
'sb9cdfae56d72cfe2': `Provenance`,
'sbbb97b1c63507dc0': `Number`,
'sbc02a7fd82592275': `File formats and upload limits:`,
'sbc2cea55676b3aca': `Enter the email address to which the login code should be sent.`,
'sbc6953a36ced943f': `privacy policy`,
'sbe9e66b2467b273b': `Artwork Permissions`,
'sbf52694503a0f322': `paused.`,
'sc14632800a845f4a': `Select tags`,
'sc21dc776d25eb55a': `error/uploadExtensionFailure`,
'sc21fb6442d110d9a': `Invited Editors`,
'sc2c901ea4b99a96a': `Remains`,
'sc2d94a6963318685': `Edit your artists profile`,
'sc34b221a0b8bc676': `upload error`,
'sc3693cd85fbd07d3': `not a boolean`,
'sc4769ec2c49fe99b': `Exhibition/Loan Chronology`,
'sc4801f580ac4e73d': `Operator`,
'sc4bbedc293a299bb': `file is missing`,
'sc592307ea80f16b9': `Unknown`,
'sc5a11c2dd9ab8cec': `private`,
'sc5b9d5ea3bd15972': `This number is automatically assigned incrementally`,
'sc622b6f2e8694aac': `Save media`,
'sc6a7cb64b423cffa': `Loaned`,
'sc7bcd1669fd8e336': `Add child artwork`,
'sc8da3cc71de63832': `Login`,
'sc93a9aa3e5bcbf5d': `Save profile`,
'sca08a0a32920416b': `No artworks found.`,
'sca71b3d15c2caa5f': `Downgrade`,
'sca7fed2bef53cb99': `Role`,
'sca974356724f8230': `Log In`,
'scaf5b41120861d9a': str`login code could not be sent`,
'scb489a1a173ac3f0': `Yes`,
'scb6a9c1a1757adbc': `You`,
'scb7ed089a649241c': `Create New Account`,
'scbbbf3cce4237b03': `required field`,
'scbf29ce484222325': ``,
'scc316262f13a1da8': `not an integer`,
'sce8271050c5b61bb': `Address (Street, Nr)`,
'scf8fcc133a2f8f5b': `Enter profile name`,
'scfa9e1e719a45ae3': `input to long`,
'sd1779b0fe8df51f2': `Art Handling Remarks`,
'sd1f0ec5501d4750b': `State Remarks`,
'sd1f44f1a8bc20e67': `eMail`,
'sd24d2099f6f4a88b': `Tabular curriculum vitae`,
'sd33f062c19e2e331': `Profile name`,
'sd55bb7d228718163': `invalid email format`,
'sd600892f7fabe04c': `Draft`,
'sd80496e9c65f1366': `Remarks`,
'sd9aa257179753e02': `Uploading File`,
'sda5c7c6d6aeb3699': `The invitation was sent successfully.`,
'sdc673e73b5c13aea': `Delete`,
'sdc8ff1d18f2ecc66': `not an integer greater 0`,
'sdcb9b5b53f8c8fc7': `Removed Artworks containing data are available in the Removed Artworks for 7 days after removal.
					Empty artworks are removed immediately.
				`,
'sdf4db55aad7f2064': `Unsaved Changes`,
'se077a13a6f7be5e3': `Year of founding and if applicable end`,
'se17f76f493601b62': `https:// ... (link to representation of the artwork)`,
'se2464636aebe3629': `Undamaged`,
'se2abc0f78904006c': `max`,
'se330c71fbddb77c9': `Location of birth`,
'se3e144f19cb4e18f': `Has Logged In Once`,
'se40b5a4765a49b54': str`File size exceeds the limit of
					${0}
					for
					${1}
					files.
				`,
'se48719d765fc8fde': `Remove Series`,
'se48bd9e6c2a3109d': `Accounts`,
'se4af3d6778f67c64': `Loading plans …`,
'se58ac13e33811f4c': `City, Country`,
'se625ae9f34125ec4': `invalid ID`,
'se629b41ac62684a1': `Additional copyright`,
'se68398e3c2c760b2': `Code`,
'se6a9371ded4b10d6': `Sub artworks`,
'se7238e44f9dcacee': `year only`,
'se77e76829df75be9': `Add series`,
'se7bee6e9a9b5394c': `Private`,
'se80bc227790b7f05': `tooltip_artwork_series`,
'se80d078fe2e23924': `not an array`,
'se82d6481ffb5248f': `Media data saved successfully`,
'se9159fcb6249fa3f': `Show Filters`,
'se926a1be4644b09d': `Stay logged in`,
'sea4f08110bb8f15d': `Remove`,
'seae1c1bb7c02a640': `error/invalidCsrfToken`,
'seb4bdd2a26f2ea23': `Select options`,
'sebec66b8aa58f583': `not a float`,
'sec72dce4f74b5328': `Creation date from`,
'sec7b97c2e906c8fc': `Start typing...`,
'seca29ce17b31f70d': `Publication`,
'see229a9dce866a10': `Select`,
'see2fcaedf9743ec6': `Location`,
'sef16aaaba716aa7d': `Amount of objects`,
'sef49aec68fd1dc66': `Name`,
'sefe9b81e0f06a907': `No activities.`,
'sf0175a45c199e862': str`login code sent to
					${0}
				`,
'sf0d50c9807f01f8f': `I do consent to the`,
'sf1d3b673c3bf9836': `active.`,
'sf21fb4f4b9e8911f': `Width`,
'sf22b76ecc1741ca7': `Organisation`,
'sf3282d80d86fcdc4': `View PDF`,
'sf3fe6b5fdb85d50a': `delete`,
'sf4b72165f60f5b60': `public`,
'sf61497d51f2c663f': `Deleted artworks`,
'sf65616fb463fe2e1': `No users invited.`,
'sf678df8359ba6257': `Failed to add artwork. Please try again.`,
'sf6947e1f919e6815': `input to short`,
'sf74160a9dc86ab8f': `Resolution`,
'sf76a183603d87542': `Create Profile for User`,
'sf78636872ec15cbb': `Enter the login code you received by email here.
					Click "Stay logged in" if you want to stay logged in on your computer for a long time.
				`,
'sf8e156354e5bacb8': `Activities`,
'sf993bb199fefbe04': `All`,
'sf9e39190a7ba37b4': `Profile saved successfully.`,
'sf9e6e6ef197c2b25': `test`,
'sfa766d8b35773ac0': `Location of death (if applicable)`,
'sfa889eb8ea9148b1': `Artwork date`,
'sfac15b89e0668996': `Duplicate`,
'sface44df32238223': `Your Profile`,
'sfb22e3d1056f6a30': `Measurements`,
'sfb4034918f62ded7': `UI Language`,
'sfb608c3ab924e85c': `file category not allowed`,
'sfdd8a3510a8b1bed': `Videos`,
'sfde5ee686b1d3d02': `Images / media copyright`,
'sfe46f400c6b86658': `view`,
'sfe7bf39909a48de6': `Series Details`,
'sff489cc579ecaf83': `Date Remark`,
'sff9d51b6c5a73163': `Alternative text`,
'sffdadf0a576fd802': `Height`,
's3ca1344d464ef56a': str`Signup not possible. Do you already have an account?`,
'sf180b666dcb88ec3': `drag`,
's374a7d9353293bb8': `Help and Support`,
'sbb588bb505779122': `Feedback`,
's9f41c259ce8ac3e5': `About AAKIO`,
'sb2357d7048c0ad01': `Terms and Conditions`,
's1f7e12b71164c5da': `Imprint`,
'sfb720fc010661f17': `Upgrade`,
's332698941530d43d': `Selected artworks`,
'sfee5e73b73adc6a1': `Subscription Settings`,
's30ae03472b93dc47': `Profiles`,
's5ed8698a2f254511': `Sign Up`,
's0ca538379f2e510d': `Enter your eMail and name to create an account`,
's3568bc3ed2afc24a': `Your Email`,
'saa4e7c3c071e6baf': `Your First Name`,
's13432c571a373c86': `Surname`,
'sc017ebc641ebe057': `Your Surname`,
's069240a491d5c033': `I am member of an association`,
'sa1c831f28e3ad021': `association_info_tooltip`,
's5def84e4ab3a4a4f': `Association Name`,
's59fe9cf3c81d3727': `Name of the Association`,
's533cc5bebc5cccf4': `Association Membership Nr`,
'sb1eb7fdfd86303fe': `Your Membership Nr`,
's3d673051a59fa8c7': `Already have an account? Login here`,
's08d06fa1616ee7e4': `Not account yet? Signup`,
's1f1c7272a2978e04': `Your current subscription`,
's046a35bfdd88a596': `Monthly`,
's0321c7dccee14a8a': `Annual`,
'sf9b8255d306b44cc': str`You are about to change your subscription to ${0}. The new ${1} price will be ${2}€.`,
's091d3d07b5b3076f': `OK`,
'se584964ba936b6f4': `Change Billing Cycle`,
'sbae864017f1dc9ca': str`You are about to change the billing cycle for your subscription. The new ${0} price will be ${1}€.`,
'saaf76b7afd7de20a': `Billing Cycle`,
's15ad93baf05b5db0': `Choose your billing cycle.`,
'sa626c909282f2e2e': `Change Billing`,
'sa40d4b1c172e3dc2': `Price on Request`,
's268ecd1cef45a9a8': `Are you sure?`,
'sb831787efad23c50': str`You are about to cancel your subscription.`,
'sd92721c87f6df874': `Cancel my Subscription`,
's4865ebe18bb34481': `scheduled to cancel.`,
'sb0462e65dc9a733e': str`Your trial ends in ${0} days.`,
's6425d05a39defa69': `Your subscription is paused. Please contact support if you wish to restart your subscription.`,
'sb7a8c724707345c4': `Payments are overdue for this account.`,
's08e2bf3c083978be': str`Your subscription will end in ${0} days.`,
's2f11e09b797a288b': `Your subscription is `,
'sa2604ffa0995cf1d': `Selected Artworks`,
's1fdf26c2a6d2fcc8': `Export Selected`,
's5204777c5878445c': `Association`,
'sb02477a2d779b1d7': `Is Org Member`,
    };
  